import { render, staticRenderFns } from "./MyEventCertification.vue?vue&type=template&id=666a3ebe&scoped=true&"
import script from "./MyEventCertification.vue?vue&type=script&lang=js&"
export * from "./MyEventCertification.vue?vue&type=script&lang=js&"
import style0 from "./MyEventCertification.vue?vue&type=style&index=0&id=666a3ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a3ebe",
  null
  
)

export default component.exports